export const selectTags = ({ tags }) => tags.tags;
export const selectNewTag = ({ tags }) => tags.tag;
export const selectTag = ({ tags }) => tags.tag;
export const selectItemTags = ({ tags }) => tags.itemTags;
export const selectAddToTag = ({ tags }) => tags.addToTag;
export const selectItemsOnTagList = ({ tags }) => tags.itemsTagList;
export const selectItemsOnResultList = ({ tags }) => tags.resultList;
